import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import PreviewImage from 'assets/images/it-management-landing-1.png'
import HeaderImage from 'assets/images/it-management-landing-header.svg'

import i18n from 'modules/core/lib/i18n'

type GetStartedBlockProps = {
  onClickCta: () => void
  ctaTitle?: string
}

const GetStartedBlock = ({ onClickCta, ctaTitle }: GetStartedBlockProps) => {
  return (
    <Box gap="s24" alignItems="center" paddingBottom="s32">
      <Box gap="s24" maxWidth="s600" textAlign="center">
        <Box gap="s24" paddingX="s48">
          <Text weight="medium" size="600" color="grey1000">
            {i18n.t('it_management.initial_setup.get_started_block.title')}
          </Text>

          <img width="100%" height="100%" src={HeaderImage} />
        </Box>

        <Text.Normal weight="medium" whiteSpace="breakSpaces">
          {i18n.t('it_management.initial_setup.get_started_block.description')}
        </Text.Normal>
      </Box>

      <Button onClick={onClickCta}>
        {ctaTitle || i18n.t('it_management.initial_setup.get_started_block.cta')}
      </Button>

      <Box>
        <img width="100%" height="100%" src={PreviewImage} />
      </Box>
    </Box>
  )
}

export default GetStartedBlock
